import { Avatar } from '@mui/material';
import classNames from 'classnames';
import { Tooltip } from 'flowbite-react';
import React from 'react';
import { Img } from 'react-image';
import { ContestReward, ContestRewardTypes, UIContest, UiContestLeaderboard } from 'types';

const ContestLeaderboardRow = ({
	userAttempt,
	isSelf = false,
}: {
	userAttempt: (UIContest & { reward?: ContestReward }) | UiContestLeaderboard;
	isSelf?: boolean;
	level?: number;
}) => {
	return (
		<div
			className={classNames(
				'min-h-[43.086px] relative flex items-center justify-between px-2 border-b-[0.083px] dark:border-[rgba(204,_221,_255,_0.10)]',
				isSelf ? 'dark:bg-[#111E2C] bg-[#FAFAFC]' : 'dark:bg-[#18222D] bg-[#FAFAFC]',
			)}
		>
			<div className="flex items-center gap-4 w-full max-w-[65%]">
				<div className="min-w-[25px] text-end dark:text-[#FAFAFC] text-[#28293D] text-sm font-[500]">
					{userAttempt?.rank}
				</div>
				<div>
					<Avatar
						sx={{ height: '26.514px', width: '26.514px', border: '0.414px solid #fff' }}
						src={userAttempt?.user?.profile?.profileImageUrl}
					/>
				</div>

				{isSelf ? (
					<div className="dark:text-[#C7C9D9] text-[#28293D] text-xs font-[500] flex items-center">
						<div className="whitespace-pre max-w-[100%] truncate text-ellipsis dark:text-[#E4E4EB] text-[#28293D] text-xs font-[500]">
							You
						</div>
						{userAttempt?.user?.flags?.isTrusted ? (
							<img
								src="/assets/verified-tag.svg"
								alt={'verified-tag'}
								width={14}
								height={14}
								className="inline-flex ml-[2px] max-w-[8.286px] max-h-[8.286px]"
							/>
						) : null}
					</div>
				) : userAttempt?.user?.name?.length > 14 ? (
					<Tooltip content={userAttempt?.user.name} placement="top">
						<div className="flex items-center">
							<div className="whitespace-pre max-w-[100%] truncate text-ellipsis dark:text-[#C7C9D9] text-[#28293D] text-xs font-[500]">
								{userAttempt?.user?.name.substring(0, 13)}...
							</div>
							{userAttempt?.user?.flags?.isTrusted ? (
								<img
									src="/assets/verified-tag.svg"
									alt={'verified-tag'}
									width={14}
									height={14}
									className="inline-flex ml-[2px] max-w-[8.286px] max-h-[8.286px]"
								/>
							) : null}
						</div>
					</Tooltip>
				) : (
					<div className="dark:text-[#C7C9D9] text-xs font-[500] flex items-center">
						<div className="whitespace-pre max-w-[100%] truncate text-ellipsis dark:text-[#C7C9D9] text-[#28293D] text-xs font-[500]">
							{userAttempt?.user?.name}{' '}
						</div>
						{userAttempt?.user?.flags?.isTrusted ? (
							<img
								src="/assets/verified-tag.svg"
								alt={'verified-tag'}
								width={14}
								height={14}
								className="inline-flex ml-[2px] max-w-[8.286px] max-h-[8.286px]"
							/>
						) : null}
					</div>
				)}
			</div>
			<div>
				{userAttempt?.reward ? (
					<div>
						{userAttempt?.reward?.type === ContestRewardTypes.MONEY ? (
							<div className="flex items-center gap-1 text-xs dark:text-[#F2F2F5] text-[#28293D] font-[500]">
								<Img src="/assets/moneyReward.svg" className="h-[14px] w-[14px]" />₹
								{userAttempt?.reward?.reward?.toLocaleString()}
							</div>
						) : (
							<div className="flex items-center gap-1 text-xs dark:text-[#F2F2F5] text-[#28293D] font-[500]">
								<Img src="/assets/level-up-coins.svg" className="h-[14px] w-[14px] max-h-[16px]" />{' '}
								{userAttempt?.reward?.reward?.toLocaleString()} coins
							</div>
						)}
					</div>
				) : (
					<div className="flex gap-[2px] items-center justify-center">
						<div className="text-xs font-[500] dark:text-white text-[#28293D]">
							{Math.round(((userAttempt as unknown as UiContestLeaderboard)?.score) ?? 0)}
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default ContestLeaderboardRow;
